import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import Paper from 'material-ui/Paper'
import Launch from 'material-ui/svg-icons/action/launch'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'
import Snackbar from 'material-ui/Snackbar'
import { FormattedMessage } from 'react-intl'
import { ALertHeaderText, AlertText } from './SeminarActions/styles'
import { checkAdminUrl, getToken } from '../../lib'
import config from '../../config/config'

export default class RoomFooterActions extends Component {
  state = {
    open: false,
    snackbarOpen: false,
    acceptClicked: false,
    declineClicked: false
  }

  handleOpen = () => {
    this.setState({open: true})
  }

  handleClose = () => {
    this.setState({open: false})
  }

  handleTouchTap = () => {
    const {selectConferenceId} = this.props
    const token = getToken()
    this.props.deleteConference(token, selectConferenceId)
    this.setState({
      open: false,
      snackbarOpen: false
    })
  }

  handleRequestClose = () => {
    this.setState({
      snackbarOpen: false
    })
  }

  render () {
    const {
      name,
      decline,
      register,
      token,
      id,
      jwt_token_admin,
      jwt_token_guest,
      end
    } = this.props.conferenceDetails
    const authToken = getToken()

    const path = window.location.pathname.split('/')
    const seminarURL = config.VIDEO_URL + '/'

    return (
      <Paper
        className="flex justify-between items-center pl3 pr3"
        style={{height: '10vh', borderTop: '2px solid #e3e3e3'}}
      >
        {checkAdminUrl(this.props.pathname) ? (
          <FlatButton
            onTouchTap={this.handleOpen}
            backgroundColor="#F7E1E4"
            labelStyle={{color: '#F01631'}}
            label={<FormattedMessage id="seminar.deleteButtonLabel"/>}
          />
        ) : (
          <div>
            {!end && (
              <div>
                {register ? (
                  ''
                ) : (
                  <FlatButton
                    disabled={decline}
                    onTouchTap={() => {
                      this.setState({declineClicked: true})
                      this.props.respondToInvitation(
                        token,
                        false,
                        id,
                        authToken
                      )
                    }}
                    style={{marginRight: '1rem', opacity: decline ? 0.2 : 1}}
                    backgroundColor="#F7E1E4"
                    labelStyle={{color: '#F01631'}}
                    label={<FormattedMessage id="seminar.declineInvite"/>}
                  />
                )}
                {decline && !end ? (
                  ''
                ) : (
                  <FlatButton
                    disabled={register}
                    onTouchTap={() => {
                      this.setState({acceptClicked: true})
                      this.props.respondToInvitation(
                        token,
                        true,
                        id,
                        authToken
                      )
                    }}
                    style={{marginRight: '1rem', opacity: register ? 0.2 : 1}}
                    backgroundColor="#29B87A"
                    hoverColor="#1b8859"
                    labelStyle={{color: '#FFFFFF'}}
                    label={<FormattedMessage id="seminar.acceptInvite"/>}
                  />
                )}
              </div>
            )}
          </div>
        )}
        <div>
          {checkAdminUrl(this.props.pathname) &&
          this.props.upcoming && (
            <Link
              to={`/registration/${id}`}
            >
              <FlatButton
                style={{
                  color: '#4688F1',
                  paddingLeft: '1rem',
                  paddingRight: '1rem'
                }}
              >
                <div className="flex justify-center">
                    <span className="flex justify-center items-center">
                      <FormattedMessage id="seminar.register"/>
                    </span>
                  <span className="pl3 white-90 flex justify-center items-center">
                      <Launch color="#4688F1"/>
                    </span>
                </div>
              </FlatButton>
            </Link>
          )}
          {!end && (
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={`${seminarURL}webinar/?token=${checkAdminUrl(this.props.pathname)
                ? jwt_token_admin
                : jwt_token_guest}`}
            >
              <FlatButton
                style={{
                  color: '#4688F1',
                  paddingLeft: '1rem',
                  paddingRight: '1rem'
                }}
              >
                <div className="flex justify-center">
                  <span className="flex justify-center items-center">
                    <FormattedMessage id="seminar.open"/>
                  </span>
                  <span className="pl3 white-90 flex justify-center items-center">
                    <Launch color="#4688F1"/>
                  </span>
                </div>
              </FlatButton>
            </a>
          )}
        </div>
        <Dialog
          contentStyle={{width: 430}}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <div className="flex justify-between items-center">
            <ALertHeaderText>
              <FormattedMessage id="seminar.deleteModalHeading"/>
            </ALertHeaderText>
            <div>
              <IconButton
                onTouchTap={this.handleClose}
                iconStyle={{fill: '#afb8c5'}}
              >
                <Clear/>
              </IconButton>
            </div>
          </div>
          <AlertText className="mt3 mb3">
            <FormattedMessage id="seminar.deleteConfirm.sure"/>
            {name}
            <FormattedMessage id="seminar.deleteConfirm.seminar"/>

            {false && (
              <FormattedMessage id="seminar.deleteConfirm.guestNumbers"/>
            )}
          </AlertText>
          <div className="flex justify-end">
            <div className="w4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                fullWidth
                onTouchTap={this.handleClose}
              />
            </div>
            <div className="ml2 w4">
              <FlatButton
                label={<FormattedMessage id="seminar.deleteButtonLabel"/>}
                fullWidth
                backgroundColor="#F01631"
                onTouchTap={this.handleTouchTap}
                labelStyle={{color: '#FFFFFF'}}
              />
            </div>
          </div>
        </Dialog>
        {false && <Snackbar
          style={{left: 200, bottom: 30}}
          open={this.state.snackbarOpen}
          message={<FormattedMessage id="seminar.delMessage"/>}
          action="dismiss"
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />}
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Seminars/RoomFooterActions.js